import { render } from "./MisClases.vue?vue&type=template&id=7704965e"
import script from "./MisClases.vue?vue&type=script&lang=js"
export * from "./MisClases.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__